
<template>
  <div :class="classes">
    <pt-page-title v-if="!hideTitle" title="全部样品" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="filterForm.searchKey">
      <div slot="before-left" style="position: relative;height:45px;">
        <el-button type="primary" @click="goCreated">新建样品</el-button>
        <pt-page-menu-filter :isRouteQuery="false" :tabs="tabs" v-model="selectTab" state="targetStatus" :class="$style.menufilter"></pt-page-menu-filter>
      </div>
    </pt-page-title>
    <pt-page-factor-filter labelWidth="120px" :labels="filterLabels" :displayVertical="true" v-model="filterForm" ref="filter">
      <template slot="clientOrganizationId">
        <organization-selector v-model="filterForm.clientOrganizationId" :filterable="true"></organization-selector>
      </template>
      <template slot="labExamItemId">
        <lab-product-selector v-model="filterForm.labExamItemId" :filterable="true"></lab-product-selector>
      </template>
      <template slot="examBasis">
        <lab-exambasis-selector v-model="filterForm.examBasis" :filterable="true"></lab-exambasis-selector>
      </template>
      <template slot="experimenter">
        <lab-staff-selector isName v-model="filterForm.experimenter"></lab-staff-selector>
      </template>

      <div :class="$style['buttons']">
        <div>
          <el-button type="primary" @click="handleFilter()">筛选</el-button>
					<template v-if="hasDownload">
            <el-button type="primary" @click="downloadExcel" :loading="downloadLoading">下载</el-button>
            <el-button type="primary" @click="downloadHistory">下载历史</el-button>
					</template>
          <template v-if="!hideTitle">
            <el-button type="primary" @click="exportExcel" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportExcel(true)" :loading="exportLoading" v-if="!noAllExport">全部导出</el-button>
            <el-button type="primary" @click="exportHistory">导出历史</el-button>
            <el-button type="primary" @click="importHistory">导入历史</el-button>
          </template>
          <template v-else>
            <template v-if="!noExportOption">
              <el-button type="primary" @click="exportExcel" :loading="exportLoading">导出样品列表</el-button>
              <el-button type="primary" @click="exportExcel(true)" :loading="exportLoading">全部导出</el-button>
              <el-button type="primary" @click="exportHistory">导出历史</el-button>
            </template>
            <el-button type="text" @click="toggleFilter">{{expandFilter ? '收起' :'展开'}}筛选条件</el-button>
          </template>

          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        </div>
        <div>
          <slot name="otherBtn" />
        </div>
      </div>
    </pt-page-factor-filter>
    <!-- table -->
    <pt-gene-lab-order-table ref="table" :needRefreshOrder="needRefreshOrder" :tableLabels="tableLabels" @exportSuccess="exportSuccess" @downSuccess="downSuccess" :isShowCheckbox="true" @selection-change="updateSelectedData" @getAllSize="getAllSize" :isDistribute="isDistribute" :filterAssginPre="filterAssginPre" :billId="billId" :onlyNoBill="onlyNoBill" :params="params" :taskId="taskId" :orderStatusEnum="orderStatusEnum" :isDialog="isDialog">
      <template slot="orderStatus" slot-scope="scope">
        {{scope.row.orderStatusEnum_text}}
        <el-tag v-if="scope.row.urgent" type="danger" size="small">加急</el-tag>
      </template>
      <template slot-scope="scope">
        <el-button type="text" @click.stop="goDetail(scope.row.id)">详情
        </el-button>
      </template>
    </pt-gene-lab-order-table>
  </div>
</template>

<script>
// 组件class前缀
import fillUrl from '@/mixins/fillUrl'
import ptPageTitle from 'cps/base/pt-page-title'
import organizationSelector from 'cps/selector/organization-selector.vue'
import labProductSelector from 'cps/selector/lab-product-selector.vue'
import labExambasisSelector from 'cps/selector/lab-exambasis-selector.vue'
import labStaffSelector from 'cps/selector/lab-staff-selector.vue'
import ptGeneLabOrderTable from './pt-gene-lab-order-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
import { filterFactor, filterFactor_some, tabs, tableLabels } from './lab-order-options.js'

const prefixCls = 'pt-gene-lab-order'

export default {
  name: 'pt-gene-lab-order',
  mixins: [fillUrl],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
		hasDownload:Boolean,
    hideTitle: {
      type: Boolean,
      default: false
    },
    billId: {
      type: String,
      default: ''
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    isDistribute: {
      type: Boolean,
      default: false
    },
    filterAssginPre: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String,
      default: ''
    },
    orderStatusEnum: String,
    onlyNoBill: Boolean,
    exportLoading: Boolean,
    noAllExport: Boolean,
    needRefreshOrder:Boolean,
    comePage: String, // 来自页面（委托单详情或任务详情）
    noExportOption: Boolean, // 不需要导出操作
    canSelect: Boolean// 是否可直接选择（用于委托单详情页面的样本导出，选择之后无需传出直接在列表页面做导出处理）
  },
  components: {
    ptPageTitle,
    ptGeneLabOrderTable,
    organizationSelector,
    labProductSelector,
    labExambasisSelector,
    labStaffSelector
  },
  data () {
    return {
      tabs,
      tableLabels,
      expandFilter: false,
      filterLabels: this.hideTitle ? filterFactor_some.slice(0, 4) : filterFactor,
      // 筛选表单
      filterForm: {},
      params: {},
      selectData: [],
      loading: false,
      downLoading: false,
      selectTab: 'ALL',
      rawDataloading: false
    }
  },
  watch: {
    selectTab (val, old) {
      if (val !== old) {
        const params = { ...this.filterForm }
        params.orderStatusEnum = val === 'ALL' ? null : val
        this.$refs.table.filter(params)
      }
    }
  },
  methods: {
    toggleFilter () {
      this.expandFilter = !this.expandFilter
      this.filterLabels = this.expandFilter ? filterFactor_some : filterFactor_some.slice(0, 4)
    },
    getAllSize (val) {
      this.$emit('getAllSize', val)
    },
    exportHistory () {
      this.$router.push('/export-history/lab-order?name=lab_order_export')
    },
    importHistory () {
      this.$router.push('/export-history/lab-order?name=batch&isImport=true&batchNumber=across-batches')
    },
    goCreated () {
      this.$router.push('/lab-order-form/false/0')
    },
    downSuccess () {
      this.downLoading = false
		},
		downloadExcel(){
      let data = {}
			if (!this.selectData.length) {
          this.$message.error('请至少选择一条记录')
          return
        }
        if (this.selectData) {
          this.params.orderIds = this.selectData.map(e => e.id)
          data = this.params
				}
			this.$confirm('下载操作需要花费一定时间，完成导出后我们会将数据保存在“下载历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        // this.$refs.table.exportExcel(this.params)
        this.$emit('downloadExcel', data)
      })
		},
		downloadHistory(){
			this.$router.push('/export-history/prod-task?name=lab_task_order_download')
		},
    downReports () {
      if (this.selectData) {
        this.params.ids = this.selectData.map(e => e.id)
      }
      this.$confirm('下载操作需要花费一定时间，完成下载后我们会将数据保存在“导出历史”中，您稍后下载即可。', '下载提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.downLoading = true
        this.$refs.table.downReports(this.params)
      })
    },
    cleanParams () {
      emptyObject(this.filterForm)
      this.handleFilter()
    },
    search (val) {
      if (val) {
        this.filterForm.searchKey = val
        this.handleFilter()
      }
    },
    emptySearch () {
      this.handleFilter()
    },
    reload () {
      this.$refs.table.reload()
    },
    handleFilter () {
      this.$refs.table?.filter(this.filterForm)
    },
    exportSuccess () {
      this.loading = false
    },
    exportExcel (isAll) {
      let data = {}
      if (isAll === true) {
        data = this.comePage === 'billDetail' ? { billId: this.billId } : (this.comePage === 'taskDetail' ? { taskId: this.taskId } : {})
      } else {
        if (!this.selectData.length) {
          this.$message.error('请至少选择一条记录')
          return
        }
        if (this.selectData) {
          this.params.ids = this.selectData.map(e => e.id)
          data = this.params
        }
      }
      this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        // this.$refs.table.exportExcel(this.params)
        this.$emit('getOrderExportExcel', data)
      })
      // this.selectData = []
    },
    exportRawData () {
      if (this.selectData) {
        this.params.ids = this.selectData.map(e => e.id)
      }
      this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.rawDataloading = true
        this.$refs.table.exportRawData(this.params)
      })
      // this.selectData = []
    },
    updateSelectedData (data) {
      if (this.isDialog) {
        this.$emit('selection-change', data)
        if (this.canSelect) {
          this.selectData = data
        }
      } else {
        this.selectData = data
      }
    },
    goDetail (id) {
      this.$router.push(`/lab-order-detail/${id}`)
    }
  },
  created () {
    if (!this.isDialog) {
      this.filterForm = this.getObjectFromRoute()
      this.params = this.getObjectFromRoute()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.buttons {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.button__box {
  min-width: 100px;
  > big {
    font-size: 18px;
    font-weight: bold;
  }
}
.menufilter {
  width: 10rem;
  position: absolute;
  top: 0;
  left: 55%;
  transform: translateX(-50%);
}
</style>
